import React, { Component } from 'react';
import { Modal, Button, Input, Tooltip } from 'antd';
import { connect } from 'dva';
import ListPage from '../../../../../../../components/ListPage';
import TreeSelectChannel from '../../../../ArticlePublished/components/TreeSelectChannel';
import { getAppCode } from '../../../../utils/utils';
import { convertData, getLabelStrData } from '../../../../utils/convertData';
import styles from './index.less';

const { ListTable } = ListPage;

@connect(({ courseManage }) => {
  return {
    ...courseManage,
  };
})


class CourseContentModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      totalElements: 0,
      visible: false,
      alreadyPushList: {},
      params: {
        title: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        channelId: '',
        labelId: 0,
        newsTypes: '2',
      },
      treeChannelData: [],
      chooseCourseData: [],
      chooseCourseId: []

    };

  }

  componentDidMount() {
    const { params } = this.state;
    this.fetchChannelList();
    this.fetchNewsManagerList(params);
    this.setColumns()
  }


  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        render: text => {
          if (text.length <= 20) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '类型',
        dataIndex: 'newstype',
        key: 'newstype',
        width: 100,
        render: () => {
          return '视频素材';
        },
      },
    ];
    this.setState({ columns });
  };

  fetchNewsManagerList = params => {
    const { dispatch } = this.props;
    const { alreadyPushList } = this.state;

    dispatch({
      type: 'courseManage/fetchNewsManagerList',
      params,
    })
      .then(res => {
        this.setState({

          dataSource: getLabelStrData(res, alreadyPushList),
          totalElements: res.totalElements,
        });
      })
      .catch(() => {

      });
  };

  setChannelId = id => {
    const { params } = this.state;
    this.setState({ params: { ...params, page: 1, channelId: id } });
  };


  fetchChannelList = () => {
    const { dispatch } = this.props;

    dispatch({
      type: 'courseManage/fetchChannelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        const data = [{ value: 0, label: '全部栏目', children: convertData(res || []) }];
        const channelList = convertData(res || []);
        channelList.unshift({ value: 0, label: '全部', children: [] });
        this.setState({
          treeChannelData: data,

        });
      })
      .catch(() => {

      });
  };

  onOk = () => {
    const { chooseCourse } = this.props;
    const { chooseCourseData, chooseCourseId } = this.state;
    chooseCourse(chooseCourseId, chooseCourseData)
    this.setState({
      visible: false
    })
  }

  chooseCourseData = (selectedRowKeys, selectedRows) => {
    this.setState({
      chooseCourseData: selectedRows,
      chooseCourseId: selectedRowKeys
    })
  }

  search = e => {
    e.preventDefault();
    const searchData = e.target.value
    const { params } = this.state;
    const tempParams = {
      ...params,
      title: searchData ? encodeURIComponent(searchData) : '',
      page: 1,
    };
    this.setState({
      params: tempParams,
    });
    this.fetchNewsManagerList(tempParams);
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchNewsManagerList(tempParams);
  };

  render() {
    const { visible, treeChannelData, params, totalElements, columns, dataSource } = this.state;
    const { page } = params;
    const { checkedData } = this.props;
    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      rowSelection: {
        type: 'radio',
        onChange: (selectedRowKeys, selectedRows) => this.chooseCourseData(selectedRowKeys, selectedRows)
      },
      onPageChange: this.changePage,
    };

    return (
      <>
        <Button onClick={() => this.setState({
          visible: true
        })}
        >
          {checkedData?.length ? '重新选择' : '选择'}
        </Button>
        {
          !!checkedData?.length && (
            <div className='choose-content'>
              <img src='https://s.xiaoyuanhao.com/file/098b96c6-d701-4a0a-9aa6-47cd924ff337.svg' alt='' />
              <span>{checkedData && checkedData[0].title}</span>
            </div>
          )
        }

        <div className='tips'>完成条件: 学员累计学习时长达到管理员设置的时长要求</div>
        <Modal
          width={720}
          className={styles['course-content-modal']}
          centered
          title='课程内容选择'
          visible={visible}
          onOk={() => this.onOk()}
          onCancel={() => this.setState({
            visible: false
          })}

          footer={[
            <div><span style={{ color: '#F31A1A' }}>*</span>最多选择1个素材</div>,
            <div>
              <Button onClick={() => this.setState({
                visible: false
              })}
              >
                取消
              </Button>
              <Button type="primary" onClick={() => this.onOk()}>
                确定
              </Button>
            </div>

          ]}
        >
          <section className='search-area'>
            <div>搜索：</div>
            <Input placeholder="请搜索" onPressEnter={this.search} />
          </section>
          <section className="table-area">
            <div>
              <TreeSelectChannel
                channelList={treeChannelData}
                params={params}
                fetchPublishList={this.fetchNewsManagerList}
                setChannelId={this.setChannelId}
              />
            </div>
            <div>
              <ListTable {...tableProps} />
            </div>
          </section>
        </Modal>
      </>

    );
  }
}

export default CourseContentModal;
